// SSR 환경에서의 vue3-tabs 플러그인 내부에러 존재
// Client 환경에서만 호출 될 수 있도록 파일 생성
// vue 파일 내에서 import 하지 않고 사용가능(전역 컴포넌트)

import { defineNuxtPlugin } from '#app'
import { Tabs, Tab } from 'vue3-tabs'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('Tabs', Tabs);
  nuxtApp.vueApp.component('Tab', Tab);
});
